export function stringToSVG(svgString) {

  const element = document.createElement('div');

  element.innerHTML = svgString;

  return element.firstChild;

}